import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const QueryHomeCustomer = data => {
    return api.post(`${baseApi}/dataBoard/getCustomerInfo4PersonBoard`, data);
};

export const QueryHomeIncome = data => {
    return api.post(`${baseApi}/dataBoard/getIncomeInfo4PersonBoard`, data);
};

export const QueryHomeReturn = data => {
    return api.post(`${baseApi}/dataBoard/getReturnInfo4PersonBoard`, data);
};

export const QueryHomeVisit = data => {
    return api.post(`/dataBoard/getVisitInfo4PersonBoard`, data);
};

export const QueryCompetorList = () => {
    return api.get(`${baseApi}/customerCompetitor/updateCustomerCompetitorBidInfo`);
};

// 客户信息
export const QueryCustomerHome = () => {
    return api.get(`/home/getCustomerInfo`);
};

// 拜访数据

export const QueryVisitHome = () => {
    return api.get(``);
};

// 各模块的数据
export const QueryMainData = () => {
    return api.get(``);
};
